import { useState, useEffect, createContext, useContext } from "react";
import { API_URL } from "@/config";

const SubscriberContext = createContext();

export const useSubscribers = () => {
  const context = useContext(SubscriberContext);
  if (!context) {
    throw new Error('useSubscribers must be used within a SubscriberProvider');
  }
  return context;
};

export const SubscriberProvider = ({ children }) => {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const res = await fetch(`${API_URL}/api/subscribers`);
        const data = await res.json();
        setSubscribers(data);
      } catch (err) {
        console.error('Failed to fetch subscribers:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSubscribers();
  }, []);

  return (
    <SubscriberContext.Provider value={{ subscribers, loading }}>
      {children}
    </SubscriberContext.Provider>
  );
};
